import { combineReducers } from "redux";

import Selected from "./Selected";

export default combineReducers({
  Selected,
});
